import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import * as partnerConfigurationActions from "../../store/configurationService/actions";
import { ApplicationState } from "../../store";
import { useTranslation } from "react-i18next";
import * as httpClient from "../../util/httpClient";
import * as LoginActions from "../../store/loginService/actions";
import { Notification } from "../common/Notification";



const LanguagePreferenceDialog: React.FunctionComponent<{ closeDialog(): void; changeLanguage: any }> = (props) => {
    const dispatch = useDispatch();
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const preferencedLanguage = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userInfo?.preferencedLanguage ? state.loggedInUser.userInfo?.preferencedLanguage : "en"
    );
    const getPartnerLanguageOptions = () => dispatch(partnerConfigurationActions.actionCreators.getPartnerLanguageOptions());
    const partnerLanguageOptions = useSelector(
        (state: ApplicationState) => state.configurationState && state.configurationState.partnerLanguageOptions && state.configurationState.partnerLanguageOptions
    );

    const SetLanguageChange = (updateUsersLanguagePreference: boolean) => dispatch(LoginActions.actionCreators.LanguageChange(updateUsersLanguagePreference));
    const [language, setLanguage] = useState(preferencedLanguage);
    const [showNotification, setShowNotification] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const { handleSubmit } = useForm({
        mode: "onSubmit",
    });
    const onSubmit = async () => {
        setIsLoading(true);
        props.changeLanguage(language, true);
        SetLanguageChange(true);
        const requestBody = {
            LanguageId: language === "fr" ? 2 : 1
        };
        
        try {
            await httpClient.sendRequest("POST", "web/login/SetLanguageForSession", requestBody);
            await httpClient.sendRequest("POST", "api/userServices/UpdateLanguageForServices");
            document.documentElement.lang = language;
            window.location.href = window.location.href;
        } catch {
            setShowNotification(true);
            setTimeout(() => {
                window.location.href = window.location.href;
            }, 500)
        }
        finally {
            props.closeDialog();
            sessionStorage.setItem('language', language);
            sessionStorage.setItem('recallApi', JSON.stringify(true));
            setIsLoading(false);
        }
    };
    useEffect(() => {
        getPartnerLanguageOptions();
    }, []);
    useEffect(() => {
        if (showNotification) {
            Notification({
                type: "error",
                title: tLang("dashboard.languagePreferenceDialog.languageChangeErrorHeading"),
                message: tLang("dashboard.languagePreferenceDialog.languageChangeErrorMsg"),
                duration: 10,
            });
            setShowNotification(false);
        }
    }, [showNotification]);
    useEffect(() => {
        const dialog = document.getElementById("language-preference-dialog");
        const rootChild = dialog?.firstElementChild;

        if (isLoading) {
            rootChild?.classList.add("popup-loader");
        } else {
            rootChild?.classList.remove("popup-loader");
        }
    }, [isLoading]);
    return (
        <div id="language-preference-dialog">
            <div className="dialog-header">
                <div className="dialog-icon">
                    <em className="las la-globe"></em>
                </div>
                <h1> {tLang("dashboard.languagePreferenceDialog.accountLanguagePreference")}</h1>
            </div>
            <form onSubmit={handleSubmit(onSubmit)} id="protection-plan-upgrade-form-container">
                <div className={false ? "loading dialog-body" : "dialog-body"}>
                    <div className="form-row">
                        <p>{tLang("dashboard.languagePreferenceDialog.langaugeChangeContent")}</p>
                        <p>
                            <strong>{tLang("dashboard.languagePreferenceDialog.pleaseNote")}</strong> {tLang("dashboard.languagePreferenceDialog.langaugePreferenceContent")}
                        </p>
                    </div>
                    <ul role="menu" className="submenu-links" style={{ padding: "20px" }}>
                        {!!partnerLanguageOptions ? (
                            partnerLanguageOptions.map((languageObject: any) => {
                                return (
                                    <li
                                        role="presentation"
                                        key={languageObject.code}
                                        className={`margin-bottom-m ${language === languageObject.code.toLowerCase() ? "status-active" : "status-inactive"}`}
                                    >
                                        <span
                                            className="hand-pointer"
                                            role="menuitem"
                                            onClick={(e) => {
                                                setLanguage(languageObject.code.toLowerCase());
                                            }}
                                        >
                                            <em className="las la-globe"></em>
                                            <span style={{ marginLeft: "10px" }}>{languageObject.displayName}</span>
                                        </span>
                                    </li>
                                );
                            })
                        ) : (
                            <li role="presentation" className={`margin-bottom-m ${language === "en" ? "status-active" : "status-inactive"}`}>
                                <span
                                    className="hand-pointer"
                                    role="menuitem"
                                    onClick={(e) => {
                                        setLanguage("en");
                                    }}
                                >
                                    <em className="las la-globe"></em>
                                        <span style={{ marginLeft: "10px" }}>English</span>
                                </span>
                            </li>
                        )}
                    </ul>
                    <div className="line-divider margin-vertical-xs"></div>
                </div>

                <div className="dialog-footer">
                    <div className="row between-xs">
                        <div className="col-xs col-no-gutter flex-grow-null">
                            <button type="button" className="btn-default" id="btn-submit-purchase" disabled={false} onClick={() => props.closeDialog()}>
                                <span className="btn-text">{tLang("dashboard.languagePreferenceDialog.cancelButton")}</span>
                            </button>
                        </div>
                        <div className="col-xs col-no-gutter flex-grow-null">
                            <button type="submit" className="btn-default btn-primary" id="btn-submit-purchase" disabled={false}>
                                <span className="btn-text">{tLang("dashboard.languagePreferenceDialog.continueButton")}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default LanguagePreferenceDialog;
